import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type PatientRecapSourceSessionClickedEventProps } from '@heidi/patients/contracts';

/**
 * The app-side emit host for `patient_recap_source_session_clicked`
 * (`@heidi/patients`), openspec task 2.1b.
 *
 * Ruling 24: the recap header decides WHEN the event fires — the clinician
 * clicking the source-session date link — and supplies the payload, including
 * the staleness verdict and the month delta it has already computed for the
 * label. This function adds the `event_name` and the routing.
 *
 * ROUTING IS PRESERVED, NOT TIDIED, and here that means passing NO `options`.
 * The Rematch wrapper this replaces
 * (`analyticsScribe.trackPatientRecapSourceSessionClicked`) called `trackEventV2`
 * with no destination control — unlike its `trackPatientSearched` neighbour,
 * which passes `{ amplitude: false }` — so this event does reach Amplitude and
 * must keep doing so. Adding `{ amplitude: false }` here would look like tidying
 * and would silently stop an Amplitude series. `trackV2` is a pure alias of
 * `track` (`src/lib/analytics/track-v2.ts`), so the same function object receives
 * the same payload; the only thing that changed is that the store is no longer
 * on the path.
 *
 * WHY THE ENUM MEMBER AND NOT `patientRecapSourceSessionClicked.name`:
 * `event_name` discriminates `TrackingEventV2` on string ENUM members and a
 * string literal does not compile in one's place. The agreement is asserted in
 * this module's suite instead.
 */
export const trackPatientRecapSourceSessionClicked = (
  props: PatientRecapSourceSessionClickedEventProps
): void => {
  track({
    event_name: TrackingEventName.PatientRecapSourceSessionClicked,
    props,
  });
};
